import { useMutation, useQueryClient } from 'react-query'

import {
  cardRepository,
  SpendingCardKeys,
} from '@webapp/modules/spending-cards'

export const useMutateLockCardAdmin = () => {
  const queryClient = useQueryClient()

  const { mutateAsync } = useMutation({
    mutationFn: async ({ externalId }: { externalId: string }) => {
      return cardRepository.lockCardAdmin(externalId)
    },
  })

  const lockCard = async ({ externalId }: { externalId: string }) => {
    await mutateAsync({ externalId })

    await queryClient.invalidateQueries([...SpendingCardKeys.GET_CARDS_ADMIN])
    await queryClient.invalidateQueries([
      ...SpendingCardKeys.GET_CARD_COUNTS_ADMIN,
    ])
  }

  return { lock: lockCard }
}
